import axios from "axios";
export default {
  updateState: (id, state) => axios.put(`/api/maintenance/${id}`, state),
  report: (id, cancelToken) => axios.get(`/api/maintenance/${id}/report`, { cancelToken, responseType: "blob" }),
};
